/**
 *
 * Asynchronously loads the component for Forbidden
 *
 */

import { lazyLoad } from 'src/utils/loadable';

export const Forbidden = lazyLoad(
  () => import('./index'),
  (module: { Forbidden: any }): any => module.Forbidden,
);
